import React, { useEffect, useState } from "react";
import { Loader2, Pencil } from "lucide-react";
import { reApi, errMsg } from "@/lib/residentApi";
import { ReviewCard } from "./reviewParts";
import { EditToggle, ErrorLine, GhostButton, GoldButton, inputCls, labelCls } from "./ui";

function EditReview({ rid, r, onDone, onCancel }) {
  const [summary, setSummary] = useState(r.summary || "");
  const [note, setNote] = useState(r.note || "");
  const [err, setErr] = useState(null);
  const save = async () => {
    setErr(null);
    try { await reApi.patch(`/residents/${rid}/reviews/${r.id}`, { summary, note }); onDone(); } catch (e) { setErr(errMsg(e)); }
  };
  return (
    <li data-testid={`review-edit-${r.id}`} className="p-4 border border-nex-gold/40 rounded-sm space-y-2">
      <label><span className={labelCls}>Summary</span><textarea data-testid={`review-edit-summary-${r.id}`} rows={8} value={summary} onChange={(e) => setSummary(e.target.value)} className={inputCls} /></label>
      <label><span className={labelCls}>Staff note</span><input data-testid={`review-edit-note-${r.id}`} value={note} onChange={(e) => setNote(e.target.value)} className={inputCls} /></label>
      <ErrorLine testId={`review-edit-error-${r.id}`}>{err}</ErrorLine>
      <div className="flex justify-end gap-2">
        <GhostButton data-testid={`review-edit-cancel-${r.id}`} onClick={onCancel}>Cancel</GhostButton>
        <GoldButton data-testid={`review-edit-save-${r.id}`} onClick={save} disabled={!summary.trim()}>Save</GoldButton>
      </div>
    </li>
  );
}

export default function ReviewsTab({ resident }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);
  const [editing, setEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const load = () => reApi.get(`/residents/${resident.id}/reviews`).then((d) => setRows(d.reviews)).catch((e) => setErr(errMsg(e)));
  useEffect(() => { load(); }, [resident.id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (err) return <p data-testid="reviews-tab-error" className="text-sm text-red-300">{err}</p>;
  if (!rows) return <div className="flex items-center gap-2 text-nex-muted"><Loader2 className="h-4 w-4 animate-spin" /> Loading reviews…</div>;
  return (
    <div data-testid="reviews-tab" className="space-y-3">
      <EditToggle editing={editing} setEditing={(v) => { setEditing(v); setEditId(null); }} label="Edit reviews" testId="reviews" />
      <p className="text-[11px] text-nex-muted">Weekly touchpoint reviews. Run a new review from the Pillar Board.</p>
      {rows.length ? <ul className="space-y-3">{rows.map((r) => (editId === r.id
        ? <EditReview key={r.id} rid={resident.id} r={r} onCancel={() => setEditId(null)} onDone={() => { setEditId(null); load(); }} />
        : <div key={r.id} className="relative">
            {editing && <button type="button" onClick={() => setEditId(r.id)} data-testid={`review-edit-open-${r.id}`} className="absolute top-3 right-3 z-10 inline-flex items-center gap-1 text-[11px] text-nex-gold"><Pencil className="h-3 w-3" /> Edit</button>}
            <ReviewCard r={r} />
          </div>))}</ul>
        : <p data-testid="reviews-tab-empty" className="text-sm text-nex-muted">No reviews yet.</p>}
    </div>
  );
}
